export {Node} from './node.component'


// WEBPACK FOOTER //
// ./src/app/components/angular2-tree-diagram/node/index.ts